<script>
// 基本信息
export default {
  props: {
    info: {
      type: Object,
      required: true
    }
  },
    data() {
        return {

        };
    },
    methods: {

    },
};
</script>
<template>
    <div class="basic-info-container">
      <div class="date-location bg1">
        <div class="date font-color1"><i class="iconfont iconfont-icon-time"></i>{{ info.beginDate }} - {{ info.endDate }}</div>
        <div class="location overflow-text font-color1" v-if="info.location"><i class="iconfont iconfont-icon-address"></i>{{ info.location }}</div>
      </div>
      <div class="units">
        <div class="unit flex" v-for="unit in info.units" :key="unit.name">
          <div class="name font-color3">{{ unit.name }}：</div>
          <div class="value font-color3 overflow-text-tow">{{ unit.value }}</div>
        </div>
      </div>
    </div>
</template>

<style src="@/tbs/stylesheet/dynamic.css" />
<style src="@/tbs/stylesheet/iconfont.css" />
<style scoped lang="scss">
.basic-info-container{
  .date-location{
    padding: 6px 8px;
    font-size: 13px;
    border-radius: 4px;
    .date,.location{
      height: 30px;
      line-height: 30px;
      .iconfont{
        margin-right: 8px;
      }
    }
  }
  .units {
    margin-top: 12px;
    font-size: 13px;
    .unit {
      align-items: flex-start;
      margin-top: 8px;
      .name { min-width: 60px; }
    }
  }
}
</style>
